import React from "react";
import "./styles.scss";

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="header">404</div>

      <div className="subheader">
        Sorry, we were unable to find that page you are looking for.
      </div>

      {/* <div className="link">
        Start from <a href="/">Home Page</a>
      </div> */}
    </div>
  );
};

export default NotFound;
